import { ApolloClient } from 'apollo-client'

let _apolloClient: ApolloClient<unknown>

export const initApolloClientAccessor = <T>(client: ApolloClient<T>) => {
  _apolloClient = client
}

export default function apolloClient() {
  return _apolloClient
}
